import { daemonServiceLaneSchema } from "../daemon/service-contract.js";
import { START_BOUNDED_ID_SCHEMA } from "../start/shared.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/current-device-target.ts
const currentDeviceTargetDeviceIdSchema = START_BOUNDED_ID_SCHEMA;
const currentDeviceTargetResolvedSchema = z$1.strictObject({
	availability: z$1.literal("resolved"),
	connectedComputerId: START_BOUNDED_ID_SCHEMA.optional(),
	deviceId: currentDeviceTargetDeviceIdSchema,
	runtimeLane: daemonServiceLaneSchema
});
const currentDeviceTargetMissingSchema = z$1.strictObject({
	availability: z$1.literal("missing"),
	reasonCodes: z$1.array(z$1.string().trim().min(1).max(256)).optional()
});
const currentDeviceTargetResponseSchema = z$1.discriminatedUnion("availability", [currentDeviceTargetResolvedSchema, currentDeviceTargetMissingSchema]);
const localRuntimeEnrollmentBodySchema = z$1.strictObject({
	connectedComputerId: START_BOUNDED_ID_SCHEMA.optional(),
	runtimeLane: daemonServiceLaneSchema
});
const localRuntimeEnrollmentResponseSchema = z$1.strictObject({
	connectedComputerId: START_BOUNDED_ID_SCHEMA.optional(),
	deviceId: currentDeviceTargetDeviceIdSchema,
	runtimeLane: daemonServiceLaneSchema
});
const forgetCurrentComputerStatusSchema = z$1.enum(["forgotten", "already_missing"]);
const forgetCurrentComputerResponseSchema = z$1.strictObject({
	status: forgetCurrentComputerStatusSchema,
	forgottenDeviceId: START_BOUNDED_ID_SCHEMA.nullable(),
	currentDeviceTarget: currentDeviceTargetMissingSchema
});
const forgetComputerRouteParamsSchema = z$1.strictObject({ deviceId: currentDeviceTargetDeviceIdSchema });
const forgetComputerResponseSchema = z$1.strictObject({
	status: forgetCurrentComputerStatusSchema,
	forgottenDeviceId: START_BOUNDED_ID_SCHEMA.nullable(),
	currentDeviceTarget: currentDeviceTargetResponseSchema
});
//#endregion
export { currentDeviceTargetDeviceIdSchema, currentDeviceTargetMissingSchema, currentDeviceTargetResolvedSchema, currentDeviceTargetResponseSchema, forgetComputerResponseSchema, forgetComputerRouteParamsSchema, forgetCurrentComputerResponseSchema, forgetCurrentComputerStatusSchema, localRuntimeEnrollmentBodySchema, localRuntimeEnrollmentResponseSchema };

//# sourceMappingURL=current-device-target.js.map